import { render, staticRenderFns } from "./PreferredBanks.vue?vue&type=template&id=a7411968"
import script from "./PreferredBanks.vue?vue&type=script&lang=js"
export * from "./PreferredBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports